<template>
  <div>{{ template }}</div>
</template>

<script>
import router from "@/router/route.js";
import Step from "@/models/Step";
export default {
  props: ["step"],
  computed: {
    template() {
      let step = this.step;
      Object.keys(step).forEach((k) => step[k] == null && delete step[k]);

      delete step.id;
      delete step.survey_id;
      delete step.title;
      delete step.subtitle;
      delete step.image;
      delete step.image_link;

      step.options.forEach((option) => {

        Object.keys(option).forEach((k) => option[k] == null && delete option[k]);

        delete option.id;
        delete option.step_id;
        delete option.title;
        delete option.description;

        option.contents.forEach((content) => {

          Object.keys(content).forEach((k) => content[k] == null && delete content[k]);

          delete content.id;
          delete content.parent_id;
        });
      });

     step.rows.forEach((row) => {

       Object.keys(row).forEach((k) => row[k] == null && delete row[k]);
        delete row.id;
        delete row.parent_id;

        row.columns.forEach((column) => {

          //Object.keys(column).forEach((k) => column[k] == null && delete column[k]);
          delete column.id;
          delete column.row_id;

          column.contents.forEach((content) => {

            Object.keys(content).forEach((k) => content[k] == null && delete content[k]);
            delete content.id;
            delete content.parent_id;
          });
        });
      });

      return step.$toJson();

    },
  },
  methods: {

  removeNull(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
  }
    /*
    printStep() {
      let step = Step.query()
        .whereId(this.stepid)
        .withAllRecursive()
        .first()
        .$toJson();
      console.log(step);
    },
    */
  },
};
</script>

<style></style>
